// extracted by mini-css-extract-plugin
module.exports = {"Open":"ResourceCalendar_Open__1ao3O","Closed":"ResourceCalendar_Closed__3zhyG","LabClosed":"ResourceCalendar_LabClosed__2_YcY","LeftHeader":"ResourceCalendar_LeftHeader__mfTNu"};